export default __webpack_public_path__ + "2566661c1c0fa4636a4364a25e883234.png";